import { get } from '../../ReaderlyHttpClient';
import { DeliveryDestination } from '../UserService/Data';

export interface NovaPoshtaCityOption {
  ref: string;
  deliveryCityRef: string;
  name: string;
  present: string;
  areaName?: string | null;
  regionName?: string | null;
  settlementType?: string | null;
  warehouses: number;
  addressDeliveryAllowed: boolean;
  streetsAvailability: boolean;
}

export interface NovaPoshtaWarehouseOption {
  ref: string;
  cityRef: string;
  settlementRef?: string | null;
  cityName: string;
  number: string;
  description: string;
  shortAddress?: string | null;
  typeOfWarehouseRef?: string | null;
  categoryOfWarehouse?: string | null;
  warehouseIndex?: string | null;
  postalCode?: string | null;
}

export interface NovaPoshtaStreetOption {
  ref: string;
  name: string;
  type?: string | null;
}

class DeliveryService {
  searchNovaPoshtaCities(query: string, limit = 10): Promise<NovaPoshtaCityOption[]> {
    return get<NovaPoshtaCityOption[]>(
      'api/delivery/nova-poshta/cities',
      { query, limit },
      { suppressGlobalError: true }
    );
  }

  searchNovaPoshtaWarehouses(
    cityRef: string,
    destination: DeliveryDestination,
    query?: string,
    limit = 10
  ): Promise<NovaPoshtaWarehouseOption[]> {
    return get<NovaPoshtaWarehouseOption[]>(
      'api/delivery/nova-poshta/warehouses',
      { cityRef, destination, query, limit },
      { suppressGlobalError: true }
    );
  }

  searchNovaPoshtaStreets(cityRef: string, query: string, limit = 10): Promise<NovaPoshtaStreetOption[]> {
    return get<NovaPoshtaStreetOption[]>(
      'api/delivery/nova-poshta/streets',
      { cityRef, query, limit },
      { suppressGlobalError: true }
    );
  }
}

const deliveryService = new DeliveryService();
export default deliveryService;
